
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useEquipmentStore } from '@/entities/equipment'

export const equipmentBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { fetchAll } = useEquipmentStore()

  await fetchAll()

  next()
}
